<template>
  <tg-layout>
    <el-row type="flex" justify="start" class="info-row" align="middle">      
        <span class="tg-icon tg-icon-online tg-icon-size-2"></span><span class="ma-l-2">{{ totalUser }}</span>      
    </el-row>
    <tg-table ref="table" :columns="columns" :proxy="proxy" align="center" :fit="true" @on-loaded="handleLoaded">
      <template slot="userfullname" slot-scope="scope">
        <tg-user-full-name v-bind="scope"></tg-user-full-name>
      </template>
      <template slot="auth" slot-scope="scope">{{$t('column.l' + scope.value)}}</template>
    </tg-table>
  </tg-layout>
</template>

<script>
import TgLayout from "@/layout/TgLayout";
import TgTable from "@/components/table/TgTable";
import TgUserFullName from "@/components/slot/TgUserFullName";

import apis from "@/apis";

const api = apis.online;

export default {
  components: {
    TgLayout,
    TgTable,
    TgUserFullName,
  },
  data() {
    return {
      columns: [],
      proxy: api.getData,
      total: 0
    };
  },
  computed: {
    totalUser () {
      return this.total.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
    }
  },
  created() {
    this.$store.dispatch('app/fetch');
    api.getColumns().then((response) => {
      this.columns = response.data;
      this.$refs.table.init();
    });
  },
  methods: {
    handleLoaded(response) {
      this.total = response.data.length;
    }
  }
};
</script>